import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "dtwin-rule-aggregates"
  }, [_c('p', {
    staticClass: "pb-6 card-description"
  }, [_vm._v("\n    " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.aggregateTrigger.text')) + "\n  ")]), (_vm.rule.properties.triggeredAggregates || []).length === 0 ? _c(VBtn, {
    class: `v-btn-x mx-1 v-btn--rounded bg-rounded-button-${_vm.color}`,
    attrs: {
      "disabled": _vm.disabled,
      "color": _vm.color,
      "title": _vm.$i18n_t('Common.addNew'),
      "rounded": "",
      "text": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('add-aggregate', 0);
      }
    }
  }, [_c(VIcon, {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("fal fa-plus")]), _vm._v("\n      " + _vm._s(_vm.$i18n_t('Common.addNew')) + "\n  ")], 1) : _vm._e(), _vm._l(_vm.rule.properties.triggeredAggregates, function (aggregate, i) {
    return _c('core-n20Card', {
      key: `aggregate_${i}`,
      class: `dt-card-text-01 ${i === 0 ? 'mt-12' : ''}`,
      scopedSlots: _vm._u([{
        key: "buttons",
        fn: function () {
          return [!_vm.disabled ? _c(VBtn, {
            class: 'v-btn-x mx-1 v-btn--rounded bg-rounded-button-' + _vm.color,
            attrs: {
              "color": _vm.color,
              "title": _vm.$i18n_t('Common.delete'),
              "icon": "",
              "info": "",
              "fab": "",
              "text": ""
            },
            on: {
              "click": function ($event) {
                return _vm.$emit('delete-aggregate', i);
              }
            }
          }, [_c(VIcon, {
            attrs: {
              "dark": ""
            }
          }, [_vm._v("fal fa-trash-alt")])], 1) : _vm._e(), !_vm.disabled ? _c(VBtn, {
            class: 'v-btn-x mx-1 v-btn--rounded bg-rounded-button-' + _vm.color,
            attrs: {
              "color": _vm.color,
              "title": _vm.$i18n_t('Common.addNew'),
              "icon": "",
              "info": "",
              "fab": "",
              "text": ""
            },
            on: {
              "click": function ($event) {
                return _vm.$emit('add-aggregate', i);
              }
            }
          }, [_c(VIcon, {
            attrs: {
              "dark": ""
            }
          }, [_vm._v("fal fa-plus")])], 1) : _vm._e()];
        },
        proxy: true
      }], null, true)
    }, [_c('div', {
      staticStyle: {
        "overflow-x": "auto",
        "overflow-y": "visible"
      }
    }, [_c('div', {
      staticClass: "mx-2 my-3",
      staticStyle: {
        "display": "flex",
        "flex-direction": "row",
        "justify-content": "space-between",
        "align-items": "center",
        "min-width": "650px"
      }
    }, [_c('div', {
      staticClass: "mx-1",
      staticStyle: {
        "display": "flex",
        "min-width": "90px"
      }
    }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.ifCondition')) + "\n        ")]), _c('div', {
      staticClass: "mx-1",
      staticStyle: {
        "display": "flex"
      }
    }, [_vm.rule.properties.conditionEnabled !== false && !_vm.rule.properties.timeTriggerOnly ? _c(VSelect, {
      staticClass: "trigger-condition-change",
      attrs: {
        "disabled": _vm.disabled,
        "items": [{
          value: 'CHANGES',
          text: _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.changes')
        }, {
          value: 'EVALUATES',
          text: _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.evaluates')
        }],
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "rules": _vm.requiredRule,
        "hide-details": ""
      },
      model: {
        value: aggregate.triggerType,
        callback: function ($$v) {
          _vm.$set(aggregate, "triggerType", $$v);
        },
        expression: "aggregate.triggerType"
      }
    }) : [_vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.evaluates')) + "\n          ")]], 2), _c('div', {
      staticClass: "mx-1",
      staticStyle: {
        "display": "flex"
      }
    }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.conditionTo')) + "\n        ")]), _c('div', {
      staticClass: "mx-1",
      staticStyle: {
        "display": "flex"
      }
    }, [_vm.rule.properties.conditionEnabled !== false && !_vm.rule.properties.timeTriggerOnly ? _c(VSelect, {
      staticClass: "trigger-condition-output",
      attrs: {
        "disabled": _vm.disabled,
        "items": ['true', 'false'],
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "rules": _vm.requiredRule,
        "hide-details": ""
      },
      model: {
        value: aggregate.triggerValue,
        callback: function ($$v) {
          _vm.$set(aggregate, "triggerValue", $$v);
        },
        expression: "aggregate.triggerValue"
      }
    }) : [_c('code', [_vm._v("true")])]], 2), _c('div', {
      staticClass: "mx-1",
      staticStyle: {
        "display": "flex"
      }
    }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.doExecute')) + "\n        ")]), _c('div', {
      staticClass: "mx-1",
      staticStyle: {
        "display": "flex"
      }
    }, [_c(VSelect, {
      staticClass: "required trigger-state",
      attrs: {
        "disabled": _vm.disabled,
        "items": _vm.states,
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "rules": [..._vm.requiredRule, ..._vm.stateMetricRule],
        "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.metricState'),
        "item-text": "properties.title",
        "item-value": "id",
        "hide-details": "auto",
        "required": ""
      },
      scopedSlots: _vm._u([{
        key: "selection",
        fn: function (data) {
          return [_vm._v("\n              " + _vm._s(data.item.properties.title) + " (" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(data.item.id) + ")\n            ")];
        }
      }, {
        key: "item",
        fn: function (data) {
          return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v("\n                  " + _vm._s(data.item.properties.title) + " (" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(data.item.id) + ")\n                ")]), _c(VListItemSubtitle, {
            domProps: {
              "innerHTML": _vm._s(data.item.key)
            }
          })], 1)];
        }
      }, {
        key: "append-outer",
        fn: function () {
          return [aggregate.stateId ? _c(VBtn, {
            class: `my-0 v-btn-x v-btn--rounded bg-rounded-button-${_vm.color}`,
            attrs: {
              "color": _vm.color,
              "icon": "",
              "info": "",
              "fab": "",
              "text": ""
            },
            on: {
              "click": function ($event) {
                return _vm.openDigitalTwinOfState(aggregate.stateId);
              }
            }
          }, [_c(VIcon, {
            attrs: {
              "color": _vm.color,
              "dark": "",
              "small": "",
              "title": _vm.stateTitle(aggregate),
              "alt": _vm.stateTitle(aggregate)
            }
          }, [_vm._v("\n                  fal fa-info-circle\n                ")])], 1) : _vm._e()];
        },
        proxy: true
      }], null, true),
      model: {
        value: aggregate.stateId,
        callback: function ($$v) {
          _vm.$set(aggregate, "stateId", $$v);
        },
        expression: "aggregate.stateId"
      }
    })], 1)]), !!aggregate.stateId && _vm.stateMetricRule[0](aggregate.stateId) !== true ? _c('div', {
      staticClass: "error--text"
    }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.aggregateTrigger.stateMetricInputDescription')) + "\n      ")]) : _vm._e()])]);
  })], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };